import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { RegularSection, ColorTitle } from '@/components/Layouts'

interface Card {
    title?: string
}

interface Content {
    title?: string
    text?: string
    cards?: Card[]
}

interface S1_L3_2Props {
    content?: Content
    blockName?:string
}

const Index = (props: S1_L3_2Props) => {
    const { content = {} } = props
    const { title, text, cards = [] } = content
    return (
        <RegularSection aria-label='S1_L3_2' >
            <ColorTitle title={title} colorFrom={2} width='100%' textAlign='start'/>
            <Typography variant='body2'>{text}</Typography>
            <Grid
                container
                spacing={2}
                sx={{ width: '100%' }}
            >
                {cards.map((card, index) => (
                    <Grid
                        key={index}
                        size={{ xs: 12, md: 6, lg: 4 }}
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            borderRadius: 4,
                            gap: 3,
                            backgroundImage: 'linear-gradient(180deg, #FC0006 0%, #990000 100%)',
                            p: 2,
                            minHeight: { xs: 130 },
                        }}
                    >
                        <Typography
                            variant='h3'
                            sx={{ color: 'primary.dark', fontWeight: 'bold', fontSize: { xs: '5rem', md: '6rem'} }}
                        >
                            {'0' + (index + 1)}
                        </Typography>
                        <Typography
                            variant='h3'
                            sx={{
                                color: 'white',
                                display: 'flex',
                                flexGrow: 1,
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            {card.title}
                        </Typography>
                    </Grid>
                ))}
            </Grid>
        </RegularSection>
    )
}

export default Index
